<label for="search" style="font-weight:bold;margin-bottom:10px;display:inline-block;">Search by claim number</label>
<input #search id="search" name="search" class="form-control" placeholder="123456-AB" type="text">
<small style="margin-top: 15px; display: inline-block; margin-bottom: 15px">Closed claims with no activity for 12 months cannot be viewed online.</small>
<div *ngIf="isError" class="media alert alert-danger">
    <div class="media-left">
        <span class="nw-icon-error"></span>
    </div>
    <div class="media-body" role="alert">
        <span class="ng-scope">Claim not found. Check that you entered 6 numbers and 2 letters and try again.</span>
    </div>
</div>
<div style="width:100%;text-align:center">
    <button id="searchClaimsBtn" class="button preferred equal-width" (click)="navigateToClaimOverview(search.value)">Search claims</button>
</div>